import { useState } from 'react';
import { API_URL } from '@constants';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/spaces/max-price';

export type GetMaxPriceSuccessResponse =
    paths['string']['get']['responses']['200']['content']['application/json'];

/**
 * Requests endpoint to get max price.
 */
export const useGetMaxPrice = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [lastResponseTime, setLastResponseTime] = useState<Date | null>(null);
    const [maxPrice, setMaxPrice] = useState<number>(0);

    const request = async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.message || '') as ApiError;
                error.statusCode = response.status;
                error.errors = json.errors;
                throw error;
            }

            const json: GetMaxPriceSuccessResponse = await response.json();
            setMaxPrice(json.data.max_price);
        } catch (err: any) {
            handleCommonErrors(err);
            err.message && setError(err.message);
        } finally {
            setLoading(false);
            setLastResponseTime(new Date());
        }
    };

    return { request, maxPrice, loading, error, lastResponseTime };
};